import { api, headersConfig } from "../../services/api";

export async function getProducts(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== '' && value != null) {
            params.set(key, String(value));
        }
    });
    const query = params.toString();
    const response = await api.get(query ? `/products.php?${query}` : '/products.php');

    return response;
};

export async function getProductDetails(id) {

    const response = await api.get('/products.php?id=' + id, headersConfig);

    return response;
};